import { render, staticRenderFns } from "./HistoryPage.vue?vue&type=template&id=74c8a9e4"
import script from "./HistoryPage.vue?vue&type=script&lang=js"
export * from "./HistoryPage.vue?vue&type=script&lang=js"
import style0 from "./HistoryPage.vue?vue&type=style&index=0&id=74c8a9e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports